require("./main");
import App from "./components/views/layouts/App.vue";

// Vuex
import store from "./store/index.js";

// Route y rutas
import VueRouter from "vue-router";
import {sync} from 'vuex-router-sync';
import { routes } from "./routes.js";
const hash = CryptoJS.MD5("hsBI69O90juKhpPx").toString();
const router = new VueRouter({
    mode: "history",
    base: __dirname,
    linkActiveClass: "active",
    routes: routes,
    linkExactActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {return { x: 0, y: 0 };}
});
//Crypt
window.axios.interceptors.request.use(function (config) {
    if(config && config.data && window.acceptC == true){
        let dataApp = JSON.stringify(config.data);
        dataApp = CryptoJS.AES.encrypt(dataApp, hash).toString();
        config.data = {
            'encrypt' : dataApp
        };
    }
    if(config && config.params &&  window.acceptC == true){

        let paramsApp = JSON.stringify(config.params);
        paramsApp = CryptoJS.AES.encrypt(paramsApp, hash).toString();
        config.params = {
            'encryptParams' : paramsApp
        };
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

window.axios.interceptors.response.use(function (response) {
    if(response && response.data &&  window.acceptC == true){
        if(response.config &&
            response.config.responseType &&
            response.config.responseType =='blob'){

        }else{
            let bytes  = CryptoJS.AES.decrypt(response.data.toString(), hash);
            let plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            response.data = plaintext;
        }


    }
    return response;
}, function (error) {
    const originalRequest = error.config;

    if (error.response && error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        router.push('/');
    } else if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        delete window.axios.defaults.headers.common["Authorization"];
        window.sessionStorage.removeItem('acquisition_token');
        window.axios.defaults.headers.common = {
            'Authorization': 'Bearer',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Accept-C': window.acceptC
        };
        router.push('/ingresar');
    } else {
        return Promise.reject(error);
    }
});

sync(store, router);
Vue.config.productionTip = false;

new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App),
    onIdle() {
        if ( window.sessionStorage.getItem("acquisition_token") ) {
            this.removeSession();
        }
    },
    methods: {
        removeSession() {
            axios.post("/api/logout").then(response => {
                if (response.data.authenticated === false) {
                    sessionStorage.removeItem("acquisition_token");
                    sessionStorage.removeItem("acquisition_token_expiration");
                    sessionStorage.removeItem("acquisition_keep_session");
                    sessionStorage.removeItem("acquisition_user");

                    axios.defaults.headers.common = {
                        Authorization: "Bearer"
                    };

                    this.$router.push("/ingresar");
                } else {
                    this.$message({
                        type: "warning",
                        message: "No fue posible cerrar su sesión, inténtelo nuevamente."
                    });
                }
            });
        }
    }
});


// Acción para recuperar los datos del usuario al recargar la página
if (window.sessionStorage.getItem("acquisition_token")) {
    if (store.state.user.fullname === null) {
        axios.get("/api/user/" + window.sessionStorage.getItem("acquisition_user"))
            .then(response => {
                store.commit("setUser", response.data.user);
            });
    }
}
